module.exports = __webpack_public_path__ + "img/new1-1.3ef60f3e.png";